"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISPATCH_COLUMNS = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _instants = require("web/shared/jobs/instants.js");
var _runStates = require("web/shared/jobs/runStates.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _cells = require("web/shared/jobs/cells");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What the dispatch list shows about each invocation of the dispatcher.
*
* The slot is server time and the start is local, which is why they are
* separate columns rather than one: they answer different questions ("was this
* the 05:00 run" and "when did that actually happen here").
*/ /** The dispatch's run tally, or an em dash before it is computed. */
function outcomeText(dispatch) {
  var _dispatch$succeeded, _dispatch$failed, _dispatch$skipped, _dispatch$aborted;
  if (dispatch.totalJobs == null) {
    return "—";
  }
  const parts = ["".concat(String((_dispatch$succeeded = dispatch.succeeded) !== null && _dispatch$succeeded !== void 0 ? _dispatch$succeeded : 0), " ok")];
  if (((_dispatch$failed = dispatch.failed) !== null && _dispatch$failed !== void 0 ? _dispatch$failed : 0) > 0) {
    var _dispatch$failed2;
    parts.push("".concat(String((_dispatch$failed2 = dispatch.failed) !== null && _dispatch$failed2 !== void 0 ? _dispatch$failed2 : 0), " failed"));
  }
  if (((_dispatch$skipped = dispatch.skipped) !== null && _dispatch$skipped !== void 0 ? _dispatch$skipped : 0) > 0) {
    var _dispatch$skipped2;
    parts.push("".concat(String((_dispatch$skipped2 = dispatch.skipped) !== null && _dispatch$skipped2 !== void 0 ? _dispatch$skipped2 : 0), " skipped"));
  }
  if (((_dispatch$aborted = dispatch.aborted) !== null && _dispatch$aborted !== void 0 ? _dispatch$aborted : 0) > 0) {
    var _dispatch$aborted2;
    parts.push("".concat(String((_dispatch$aborted2 = dispatch.aborted) !== null && _dispatch$aborted2 !== void 0 ? _dispatch$aborted2 : 0), " aborted"));
  }
  return "".concat(String(dispatch.totalJobs), " job(s): ").concat(parts.join(", "));
}
const DISPATCH_COLUMNS = exports.DISPATCH_COLUMNS = [{
  key: "number",
  header: "Dispatch #",
  align: "right",
  render: dispatch => (0, _cells.monoCell)(String(dispatch.sequentialDispatchId))
}, {
  key: "state",
  header: "State",
  render: dispatch => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, (0, _runStates.runStateStyle)(dispatch.state))), {}, {
    children: dispatch.state.toLowerCase()
  }))
}, {
  key: "trigger",
  header: "Trigger",
  render: dispatch => (0, _cells.mutedPill)(dispatch.trigger.toLowerCase())
}, {
  key: "slot",
  header: "Slot",
  render: dispatch => {
    var _dispatch$slotTime;
    return (0, _cells.monoCell)((_dispatch$slotTime = dispatch.slotTime) !== null && _dispatch$slotTime !== void 0 ? _dispatch$slotTime : "—");
  }
}, {
  key: "date",
  header: "Date",
  render: dispatch => (0, _cells.monoCell)((0, _instants.formatDate)(dispatch.startedAt))
}, {
  key: "started",
  header: "Started",
  render: dispatch => (0, _cells.monoCell)((0, _instants.formatTime)(dispatch.startedAt))
}, {
  key: "ended",
  header: "Ended",
  render: dispatch => (0, _cells.monoCell)((0, _instants.formatTime)(dispatch.finishedAt))
}, {
  key: "duration",
  header: "Duration",
  align: "right",
  render: dispatch => (0, _cells.monoCell)((0, _instants.formatDuration)(dispatch.startedAt, dispatch.finishedAt))
}, {
  key: "outcome",
  header: "Outcome",
  render: dispatch => (0, _cells.monoCell)(outcomeText(dispatch))
}];